export default __webpack_public_path__ + "static/media/mapview-Active.42ad57b2.svg";